import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { motion } from 'framer-motion';
import { useTheme } from '@emotion/react';

export default function WeeklyTrendsChart({ data }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl shadow-xl p-6 transition-colors duration-300 ${isDark ? 'bg-gray-900' : 'bg-white'}`}
    >
      <div className="flex justify-between items-center mb-2">
        <h2 className={`text-xl font-bold ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>Weekly Interaction Trends</h2>
        <span className="text-gray-400 text-sm">Interactions this week</span>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id="colorInt" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={isDark ? "#818CF8" : "#6366F1"} stopOpacity={0.8}/>
              <stop offset="95%" stopColor={isDark ? "#818CF8" : "#6366F1"} stopOpacity={0.1}/>
            </linearGradient>
          </defs>
          <XAxis dataKey="day" stroke={isDark ? "#d1d5db" : "#374151"} />
          <YAxis stroke={isDark ? "#d1d5db" : "#374151"} />
          <CartesianGrid strokeDasharray="3 3" stroke={isDark ? "#374151" : "#e5e7eb"} />
          <Tooltip
            contentStyle={{
              borderRadius: 12,
              boxShadow: '0 2px 8px #0001',
              background: isDark ? "#1f2937" : "#fff",
              color: isDark ? "#fff" : "#000"
            }}
          />
          <Area
            type="monotone"
            dataKey="interactions"
            stroke={isDark ? "#818CF8" : "#6366F1"}
            fillOpacity={1}
            fill="url(#colorInt)"
            strokeWidth={3}
            activeDot={{ r: 8 }}
            isAnimationActive={true}
            animationDuration={1200}
          />
        </AreaChart>
      </ResponsiveContainer>
    </motion.div>
  );
} 